import { useTheme } from "@emotion/react";
import { ClearOutlined } from "@mui/icons-material";
import {
  Box,
  Chip,
  Divider,
  IconButton,
  Tab,
  Tabs,
  Tooltip,
  Typography,
} from "@mui/material";
import { StatusChipModal } from "../../../utils/chipsErp/chipStatusModal";
import DescricaoTicketComponent from "../descricaoTicketComponent";
import MensagensTicketComponent from "../mensagensTicketComponent";
import useStyles from "./styles";
import DescricaoTicketComponentVero from "../descricaoTicketComponentVero";

export default function TicketModalContentVero(params) {
  const {
    handleClose,
    erp,
    ticketDetails,
    labelTabsErp,
    value,
    handleChange,
    isEdit,
    setTicketDetails,
    itensPublic,
    setItensPublic,
    setSnackbar,
    setIsEditTicket = () => {},
    setEditedTicket = () => {},
    setIsEditOs = () => {},
    isEditOs = false,
    setIsNewOs = () => {},
    isNewOs = false,
    isEditTicket = false,
    isCliente = false,
    isAtendimento = false,
    typeTitleModal = "Atendimento",
    configParamsErp = () => {},
    isOs = false,
  } = params;

  const theme = useTheme();
  const styles = useStyles(theme);
  return (
    <Box sx={{ ...styles.containerModal }}>
      <>
        {/* Cabeçalho */}
        <Box sx={styles.containerHeaderModal}>
          <Box sx={styles.containerIconExist}>
            <IconButton onClick={handleClose} sx={{ margin: "5px" }}>
              <ClearOutlined sx={styles.clearIcon} />
            </IconButton>
          </Box>

          <Tooltip
            title={`Atendimento - ${ticketDetails?.protocolo || ""} - (${
              ticketDetails?.cliente?.codigo_cliente || ""
            }) ${ticketDetails?.cliente?.nome || ""}`}
          >
            <Typography
              id="modal-modal-title"
              variant="h6"
              component="h2"
              sx={styles.titleModal}
            >
              {`Atendimento - ${ticketDetails?.protocolo || ""} - (${
                ticketDetails?.cliente?.codigo_cliente || ""
              }) ${ticketDetails?.cliente?.nome || ""}`}
            </Typography>
          </Tooltip>

          <Box
            sx={{
              width: "100%",
              display: "flex",
              gap: 1,
              justifyContent: "space-between",
            }}
          >
            {/* Chips de status e tipo */}
            <Box sx={{ display: "flex", gap: 1, flexWrap: "wrap" }}>
              {ticketDetails?.status && StatusChipModal(ticketDetails?.status)}
              <Tooltip title={ticketDetails?.assunto}>
                <Chip
                  size="small"
                  sx={styles.chipTypeAtendimento}
                  label={
                    <Box sx={styles.containerStatusModal}>
                      <Typography sx={styles.titleChipModal}>
                        {ticketDetails?.assunto}
                      </Typography>
                    </Box>
                  }
                />
              </Tooltip>
            </Box>
          </Box>
        </Box>

        {/* Abas */}
        <Box sx={styles.containerTabs}>
          <Tabs
            value={value}
            onChange={handleChange}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable tabs"
            allowScrollButtonsMobile
          >
            <Tab value={0} label={labelTabsErp.descricao} />
            <Tab
              value={1}
              label={`${labelTabsErp.mensagens}${
                ticketDetails?.atendimento_mensagem?.length > 0
                  ? ` (${ticketDetails?.atendimento_mensagem?.length})`
                  : ticketDetails?.reports?.length > 0
                    ? ` (${ticketDetails?.reports?.length})`
                    : ""
              }`}
            />
          </Tabs>
        </Box>

        <Divider />

        {/* Conteúdo das Abas */}
        {value === 0 && (
          <DescricaoTicketComponentVero
            configParamsErp={configParamsErp}
            ticketDetails={ticketDetails}
            erp={erp}
            isOsIxc={isOs}
          />
        )}

        {value === 1 && (
          <MensagensTicketComponent
            isEdit={false}
            ticketDetails={ticketDetails}
            setTicketDetails={setTicketDetails}
            itensPublic={itensPublic}
            setItensPublic={setItensPublic}
            isCliente={isCliente}
          />
        )}
      </>
    </Box>
  );
}
